import { gql } from '@apollo/client';

export const GET_ARTICLE = gql`
  query Article($articleId: ID!) {
    article(pk: $articleId) {
      driveUrl
      fileUrl
      id
      pk
      mediaType
      name
      namespace
      pk
      pdfUrl
      preziUrl
      type
      youtubeUrl
    }
  }
`;

export const GET_ARTICLE_READS = gql`
  query GetArticleReads($userId: String!) {
    articleReads(filters: { userId: $userId }) {
      userId
      articleId
    }
  }
`;

export const CREATE_ARTICLE_READ = gql`
  mutation CreateArticleRead($articleId: String!) {
    createArticleRead(data: { articleId: $articleId }) {
      userId
      articleId
    }
  }
`;
